import { capitalize } from "shared/src/libs/stringLib/stringLib"
import { DEFAULT_AVAILABLE_USERS } from "shared/src/constants/constants"
import { getUsers } from "shared/src/libs/apiLib/apiLib"
import { mapAccessBasedOnPermissions } from "shared/src/libs/featuresLib/featuresLib"
import { useAppContext, useConfigContext, useLoadContext } from "shared/src/libs/contextLib/contextLib"
import { UserFromDb } from "shared/src/DatabaseObjects/DatabaseObjects"
import { useMountEffect, useStickyState } from "shared/src/libs/hooksLib/hooksLib"
import { AccountTab } from "./Components/AccountTab"
import { TeamTab } from "./Components/TeamTab"
import { VolumeTab } from "./Components/VolumeTab"
import { DataTab } from "./Components/DataTab"
import { DefaultsTab } from "./Components/DefaultsTab"
import { useState } from "react"
import { IntegrationTab } from "./Components/IntegrationTab"
import { TabbedPage } from "shared/src/components/shadcn/components/layouts/TabbedPage/TabbedPage"
import { Settings as SettingsIcon, User, Users, BarChart3, Database, Settings2, Plug } from "lucide-react"

const availableSettingsTabs = {
	account: AccountTab,
	team: TeamTab,
	volume: VolumeTab,
	data: DataTab,
	defaults: DefaultsTab,
	integrations: IntegrationTab,
}

const tabIcons = {
	account: User,
	team: Users,
	volume: BarChart3,
	data: Database,
	defaults: Settings2,
	integrations: Plug,
}

export function Settings() {
	const tabParams = { colWidths: [4, 7, 1] }
	const { user } = useLoadContext()
	const { accessPermissions } = useConfigContext()
	const config = useConfigContext()
	const { company } = useAppContext()

	const settingsAccess =
		config.site === "present"
			? {
					none: ["account", "defaults"],
					read: ["account", "defaults"],
					write: ["account", "team", "volume", "data", "defaults", "integrations"],
				}
			: {
					write: ["team"],
					read: ["team"],
					none: ["team"],
				}

	const settingsTabsPerUserType = mapAccessBasedOnPermissions(user.role, "settings", settingsAccess, accessPermissions)

	const [currentTab, setCurrentTab] = useStickyState({
		initState: "account",
		storageName: "settingsTab",
		forceOptions: settingsTabsPerUserType,
	})

	// const [directDbUsers, setDirectDbUsers] = useState<{ [userId: string]: UserFromDb }>({})

	// useMountEffect(() => {
	// 	getUsers({ clientId: company.id }).then((users) => {
	// 		setDirectDbUsers(
	// 			users.reduce((indexedUsers, user) => {
	// 				indexedUsers[user.sk.slice(4)] = user
	// 				return indexedUsers
	// 			}, {})
	// 		)
	// 	})
	// })

	const tabItems = settingsTabsPerUserType.map((tab) => {
		const TabComponent = availableSettingsTabs?.[tab]
		const TabIcon = tabIcons[tab]
		const content = <div>{TabComponent && <TabComponent {...tabParams} />}</div>

		return {
			value: tab,
			label: capitalize(tab),
			content,
			icon: TabIcon,
		}
	})

	return (
		<TabbedPage
			header={{
				icon: SettingsIcon,
				title: "Settings",
			}}
			tabs={{
				items: tabItems,
				activeTab: currentTab,
				onTabChange: setCurrentTab,
			}}
		/>
	)
}
